import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../../Components/Layout";
import OrderDetail from "../../../Components/OrderMgt/OrderDetail";
import useHttpHook from "../../../Hooks/HttpHook";
import { GetOrderDetails } from "../../../utils/ApiConstant";
import { OrderLanguage } from "../../../utils/Languages";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const OrderDetailPage = () => {
  const { orderId } = useParams();

  const [orderDetail, setOrderDetail] = useState({});
  const [loading, sendRequest, error] = useHttpHook();
  const query = new URLSearchParams(window.location.search);

  const redirectUrl = query.get("redirectUrl");

  useEffect(() => {
    getDetails();
  }, [orderId]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const getDetails = async () => {
    try {
      const response = await sendRequest(`${GetOrderDetails}/${orderId}`, {
        method: "get",
      });
      if (response?.status === 1 && response?.data && !Array.isArray(response.data)) {
        setOrderDetail(response.data);
      } else {
        setOrderDetail({});
      }
    } catch (err) {
      console.log(err);
      setOrderDetail({});
    }
  };

  return (
    <Layout
      Heading={OrderLanguage.OrderDetails.heading}
      TitleMark={true}
      TitleMarkClassName="event-order-detail-title-mark"
      TitleClassName="event-order-detail-title"
      HeadClassName="event-order-detail-head"
      ExtraclassName="event-order-detail-panel"
      activeMenuId="orders"
      DetailsHead
      BackAction={
        // userDetails && page === "myevents" ? "/organizer/MyEvents" : "/"
        redirectUrl || -2
      }
    >
      <OrderDetail
        loading={loading}
        error={error}
        details={orderDetail}
        getDetials={getDetails}
      />
    </Layout>
  );
};

export default OrderDetailPage;
